import { render, staticRenderFns } from "./HuoDong1Mobile.vue?vue&type=template&id=22788e5d&scoped=true&"
import script from "./HuoDong1Mobile.vue?vue&type=script&lang=js&"
export * from "./HuoDong1Mobile.vue?vue&type=script&lang=js&"
import style0 from "./HuoDong1Mobile.vue?vue&type=style&index=0&id=22788e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22788e5d",
  null
  
)

export default component.exports